import { Input, Select, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import Icon from "../../../../assets/Icon";
import WebUtils from "../../../../utils/WebUtils";
import {
  getGenericFilterApi,
  getGenericQuestionsApi,
} from "../../../../api/candidate";
import Loader from "../../../Loader";
import GenericCard from "./GenericCard";

const GenericMain = ({ loading, setLoading, filterData, userDetail,guideId,setModuleInfo,moduleInfo }) => {
  const [clearResultsFlag, setClearResultsFlag] = useState(false);
  const [category, setCategory] = useState(null);
  const [industry, setIndustry] = useState(null);
  const [difficulty, setDifficulty] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchButtonText, setSearchButtonText] = useState("");
  const [genericSort, setGenericSort] = useState("SORT_BY_CREATION_DATE");
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [skeletonLoading, setSkeletonLoading] = useState(false);

  const onPageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    getGenericGuideDataFunc(page - 1, size, searchButtonText);
  };

  const [genericQuestions, setGenericQuestions] = useState(null);

  const getGenericGuideDataFunc = async (pageNo, pageSize, search) => {
    const url = `${getGenericQuestionsApi}?openPoolSort=${genericSort}&pageNumber=${pageNo}&pageSize=${pageSize}&searchInput=${
      search || ""
    }`;
    let body = {
      category: category || "",
      industryType: industry || "",
      difficulty: difficulty || "",
      filterRequired: category || industry || difficulty ? true : false,
      // filterRequired:  false,
    };
    setSkeletonLoading(true);

    WebUtils.httpOperations(url, body, "POST")
      .then((result) => {
        setSkeletonLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setGenericQuestions(result.data.data);
        } else {
          setGenericQuestions(null);
        }
      })
      .catch((err) => {
        setSkeletonLoading(false);
        console.log(err);
      });
  };

  const handleCategoryChange = (value) => {
    setCategory(value);
  };
  const handleIndustryChange = (value) => {
    setIndustry(value);
  };
  const handleDifficultyChange = (value) => {
    setDifficulty(value);
  };

  const handleSortChange = (value) => {
    setGenericSort(value);
  };
  const handleSearch = () => {
    setClearResultsFlag(false);
    setSearchButtonText(searchText);
    setCurrentPage(1);
    getGenericGuideDataFunc(0, pageSize, searchText);
  };
  const handleClearSearch = () => {
    setClearResultsFlag(true);
    setSearchText("");
    setSearchButtonText("");
    setCurrentPage(1);
    getGenericGuideDataFunc(0, pageSize, "");
  };

  useEffect(() => {
    if (category || industry || difficulty || genericSort) {
      setCurrentPage(1);
      getGenericGuideDataFunc(0, pageSize);
    }
  }, [category, industry, difficulty, genericSort]);
  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="preparation-container xl:w-[950px] lg:w-[800px] w-full">
        <div className="w-full flex justify-center flex-col lg:flex-row gap-4 ">
          <div className="flex-1 mt-[1rem] flex flex-wrap gap-x-8 gap-y-3 justify-center driver-all-guide-search">
            <div className="flex items-start gap-3 flex-wrap">
              {skeletonLoading ? (
                <span>
                  <Skeleton.Button
                    active
                    block
                    style={{ height: 35, width: 120 }}
                  />
                </span>
              ) : (
                <Select
                  className=""
                  value={category}
                  suffixIcon=<svg
                    width="15"
                    height="15"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 6H6.0075M1.5 3.9L1.5 7.25589C1.5 7.62277 1.5 7.80622 1.54145 7.97885C1.57819 8.1319 1.6388 8.27822 1.72104 8.41243C1.8138 8.5638 1.94352 8.69351 2.20294 8.95294L7.95441 14.7044C8.84545 15.5955 9.29097 16.041 9.80471 16.2079C10.2566 16.3547 10.7434 16.3547 11.1953 16.2079C11.709 16.041 12.1545 15.5955 13.0456 14.7044L14.7044 13.0456C15.5955 12.1545 16.041 11.709 16.2079 11.1953C16.3547 10.7434 16.3547 10.2566 16.2079 9.80471C16.041 9.29097 15.5955 8.84545 14.7044 7.95441L8.95294 2.20294C8.69351 1.94352 8.5638 1.8138 8.41243 1.72104C8.27822 1.6388 8.1319 1.57819 7.97885 1.54145C7.80622 1.5 7.62277 1.5 7.25589 1.5L3.9 1.5C3.05992 1.5 2.63988 1.5 2.31901 1.66349C2.03677 1.8073 1.8073 2.03677 1.66349 2.31901C1.5 2.63988 1.5 3.05992 1.5 3.9ZM6.375 6C6.375 6.20711 6.20711 6.375 6 6.375C5.79289 6.375 5.625 6.20711 5.625 6C5.625 5.79289 5.79289 5.625 6 5.625C6.20711 5.625 6.375 5.79289 6.375 6Z"
                      stroke="#98A2B3"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  style={{
                    width: 140,
                  }}
                  dropdownStyle={{ width: 200 }}
                  placeholder="Category"
                  allowClear
                  onChange={handleCategoryChange}
                  options={
                    filterData?.category
                      ? filterData.category.map((c) => ({ label: c, value: c })) // ✅ antd requires label & value
                      : []
                  }
                />
              )}
              {skeletonLoading ? (
                <span>
                  <Skeleton.Button
                    active
                    block
                    style={{ height: 35, width: 120 }}
                  />
                </span>
              ) : (
                <Select
                  className=""
                  value={industry}
                  disabled
                  placeholder="Industry type"
                  suffixIcon=<svg
                    width="16"
                    height="13"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.8327 8.16667H14.8327C15.7661 8.16667 16.2328 8.16667 16.5893 8.34832C16.9029 8.50811 17.1579 8.76308 17.3177 9.07668C17.4993 9.4332 17.4993 9.89991 17.4993 10.8333V16.5M10.8327 16.5V4.16667C10.8327 3.23325 10.8327 2.76654 10.651 2.41002C10.4912 2.09641 10.2363 1.84144 9.92267 1.68166C9.56615 1.5 9.09944 1.5 8.16602 1.5H5.16602C4.23259 1.5 3.76588 1.5 3.40936 1.68166C3.09576 1.84144 2.84079 2.09641 2.681 2.41002C2.49935 2.76654 2.49935 3.23325 2.49935 4.16667V16.5M18.3327 16.5H1.66602M5.41602 4.83333H7.91602M5.41602 8.16667H7.91602M5.41602 11.5H7.91602"
                      stroke="#98A2B3"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  style={{
                    width: 145,
                  }}
                  dropdownStyle={{ width: 200 }}
                  allowClear
                  onChange={handleIndustryChange}
                  options={
                    filterData?.industryType
                      ? filterData.industryType?.map((c) => ({
                          label: c,
                          value: c,
                        })) // ✅ antd requires label & value
                      : []
                  }
                />
              )}
              {skeletonLoading ? (
                <span>
                  <Skeleton.Button
                    active
                    block
                    style={{ height: 35, width: 120 }}
                  />
                </span>
              ) : (
                <Select
                  className=""
                  placeholder="Difficulty"
                  value={difficulty}
                  suffixIcon=<svg
                    width="15"
                    height="15"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.40156 1.8778C8.59363 1.48869 8.68966 1.29413 8.82004 1.23197C8.93347 1.17789 9.06525 1.17789 9.17869 1.23197C9.30906 1.29413 9.4051 1.48869 9.59717 1.8778L11.4194 5.56944C11.4761 5.68432 11.5045 5.74176 11.5459 5.78635C11.5826 5.82584 11.6266 5.85783 11.6754 5.88056C11.7306 5.90623 11.794 5.91549 11.9208 5.93402L15.9968 6.5298C16.4261 6.59253 16.6407 6.6239 16.74 6.72874C16.8264 6.81995 16.8671 6.94529 16.8506 7.06985C16.8317 7.21302 16.6763 7.36436 16.3656 7.66702L13.4172 10.5387C13.3253 10.6282 13.2794 10.673 13.2497 10.7263C13.2235 10.7734 13.2066 10.8252 13.2001 10.8788C13.1928 10.9393 13.2036 11.0025 13.2253 11.129L13.921 15.1851C13.9944 15.6129 14.031 15.8269 13.9621 15.9538C13.9021 16.0642 13.7955 16.1417 13.6719 16.1646C13.5299 16.1909 13.3378 16.0899 12.9536 15.8879L9.30966 13.9716C9.19613 13.9119 9.13936 13.882 9.07955 13.8703C9.0266 13.8599 8.97213 13.8599 8.91918 13.8703C8.85937 13.882 8.8026 13.9119 8.68906 13.9716L5.04512 15.8879C4.66095 16.0899 4.46886 16.1909 4.32683 16.1646C4.20325 16.1417 4.09662 16.0642 4.03663 15.9538C3.96768 15.8269 4.00437 15.6129 4.07774 15.1851L4.77342 11.129C4.79511 11.0025 4.80595 10.9393 4.79862 10.8788C4.79212 10.8252 4.77528 10.7734 4.74902 10.7263C4.71937 10.673 4.67341 10.6282 4.5815 10.5387L1.63315 7.66702C1.3224 7.36436 1.16703 7.21302 1.14812 7.06985C1.13167 6.94529 1.17231 6.81995 1.25872 6.72874C1.35804 6.6239 1.57266 6.59253 2.00189 6.5298L6.07794 5.93402C6.2047 5.91549 6.26808 5.90623 6.32328 5.88056C6.37215 5.85783 6.41615 5.82584 6.45284 5.78635C6.49427 5.74176 6.52262 5.68432 6.57933 5.56944L8.40156 1.8778Z"
                      stroke="#98A2B3"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  style={{
                    width: 110,
                  }}
                  allowClear
                  onChange={handleDifficultyChange}
                  options={
                    filterData?.difficulty
                      ? filterData.difficulty?.map((c) => ({
                          label: c,
                          value: c.toLowerCase(),
                        })) // ✅ antd requires label & value
                      : []
                  }
                />
              )}
            </div>
            <div className="flex items-center justify-center gap-2 flex-wrap">
              {skeletonLoading ? (
                <span>
                  <Skeleton.Button
                    active
                    block
                    style={{ height: 35, width: 250 }}
                  />
                </span>
              ) : (
                <Input
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  className="w-[270px] px-2 py-[0.36rem] border border-[#D0D5DD] shadow-sm"
                  prefix={<Icon type="search-icon" />}
                  // size="large"
                  placeholder="Search"
                  onPressEnter={handleSearch}
                />
              )}
              {skeletonLoading ? (
                <span>
                  <Skeleton.Button active block style={{ height: 35 }} />
                </span>
              ) : (
                <button
                  className="btn-orange py-[0.35rem] px-[1rem] text-[.9rem]"
                  onClick={handleSearch}
                >
                  Search
                </button>
              )}
              {searchButtonText && !skeletonLoading && (
                <button
                  className="btn-white py-[0.35rem] px-[1rem] text-[.9rem]"
                  onClick={handleClearSearch}
                >
                  Clear
                </button>
              )}
              {skeletonLoading ? (
                <span>
                  <Skeleton.Button
                    active
                    block
                    style={{ height: 35, width: 130 }}
                  />
                </span>
              ) : (
                <Select
                  value={genericSort}
                  className="driverjs-all-guide-date-filer"
                  defaultValue="SORT_BY_CREATION_DATE"
                  suffixIcon=<svg
                    width="15"
                    height="15"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                      stroke="#344054"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  style={{
                    width: 130,
                  }}
                  dropdownStyle={{ width: 190 }}
                  onChange={handleSortChange}
                  options={[
                    {
                      value: "SORT_BY_CREATION_DATE",
                      label: "Sort by date",
                    },
                    {
                      value: "SORT_BY_VIEW",
                      label: "Sort by views",
                    },
                    {
                      value: "SORT_BY_PRACTICE",
                      label: "Sort by practices",
                    },
                  ]}
                />
              )}
            </div>
          </div>
        </div>
        <div className="mt-6 w-full">
          {skeletonLoading ? (
            <>
              <Skeleton.Button
                active
                block
                style={{ height: 180, marginBottom: 12 }}
              />
              <Skeleton.Button
                active
                block
                style={{ height: 180, marginBottom: 12 }}
              />
            </>
          ) : (
            <GenericCard
              genericQuestions={genericQuestions}
              setGenericQuestions={setGenericQuestions}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={onPageChange}
              userDetail={userDetail}
              setLoading={setLoading}
              guideId={guideId}
              setModuleInfo={setModuleInfo}
              moduleInfo={moduleInfo}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default GenericMain;
